import { apiSlice } from '@/api';
import { TopUpPayload, WalletBalance, WalletBalanceResponse } from './types';

export const walletApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWallet: builder.query<WalletBalance, void>({
      query: () => ({
        url: 'v1/wallet',
      }),
      providesTags: ['Balance'],
      transformResponse: (response: WalletBalanceResponse) => response.result,
    }),
    topUp: builder.mutation<{ result: string }, TopUpPayload>({
      query: (body) => ({
        url: 'v1/payment/session/top-up',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetWalletQuery, useTopUpMutation } = walletApi;
